module.exports = __webpack_public_path__ + "img/b_KalsiyForte_left.4e0c5ae7.jpeg";